// extracted by mini-css-extract-plugin
export default {"cellTable":"TableCell_cellTable__zQD4T","cell":"TableCell_cell__4OYhi","active":"TableCell_active__NBGzf"};